module.exports = "/_next/static/images/uvBackground-d7b29100de2a8750b503a1f85a050c85.png";